import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/api/client";
import { clearRefData } from "@/pages/paymentDesk/shared/refDataStore";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("sdi_token");
    const storedUser = localStorage.getItem("sdi_user");
    if (storedToken && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        localStorage.removeItem("sdi_user");
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (employeeId, pin) => {
    const res = await client.post("/auth/login", { employee_id: employeeId, pin });
    const { access_token, user: u } = res.data;
    localStorage.setItem("sdi_token", access_token);
    localStorage.setItem("sdi_user", JSON.stringify(u));
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("sdi_token");
    localStorage.removeItem("sdi_user");
    clearRefData();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
